<template>
  <div class="title" :style="`height: ${height}px;`">
    <div class="t-left">
      <div class="l-top">
        <p class="text" :style="`margin-left:${margin}px`">{{ gettitle(title) }}</p>
        <p class="text2" v-if="extend">/</p>
        <p class="text2" v-if="extend">{{ extend }}</p>
        <div class="more-btn" @click="tomore" v-if="isMore">查看更多></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from '@/components/scopetitle/method.js'

export default {
  name: 'scopetitle.textTitle2',
  props: {
    title: {
      type: [String, Object],
      default: ""
    },
    height: {
      type: String,
      default: "40"
    },
    margin: {
      type: String,
      default: "0"
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extend: ''

    };
  },
  watch: {},
  methods: {
    ...methods

  },
  mounted() { },
};
</script>

<style scoped lang="scss">
.title {
  height: 40px;
  pointer-events: auto;
}

.t-left {
  .l-top {
    height: 37.5px;
    background: url('@/assets/scopetitle/title2-wide.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 4px 0 0 80px;

    .text {
      font-weight: 400;
      font-size: 17px;
      color: #FFFFFF;
    }

    .text2 {
      margin-left: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #8798AC;
      line-height: 12px;
    }

    .more-btn {
      margin: 0 24px 0 auto;
      font-size: 14px;
      color: #51a0f4;
      cursor: pointer;
      pointer-events: auto;
    }
  }
}
</style>